module.exports = __webpack_public_path__ + "img/sync_success.ba9b51ba.svg";